export default {
  halt: 'Halt',
  halt_all: 'Halt All',
  'halt_all.optional_reason': 'Optional reason',
  'halt_all.success': 'Test successfully halted.',
  'halt_all.error':
    'There was an issue halting all tests. Please try again later.',
  'halt_all.description':
    'This will halt all currently running tests, experiments, etc. within your company.'
}
